import { render } from "./Dialog-jinkosuii.vue?vue&type=template&id=2c327859&scoped=true"
import script from "./Dialog-jinkosuii.vue?vue&type=script&lang=js"
export * from "./Dialog-jinkosuii.vue?vue&type=script&lang=js"

import "./Dialog-jinkosuii.vue?vue&type=style&index=0&id=2c327859&lang=css"
import "./Dialog-jinkosuii.vue?vue&type=style&index=1&id=2c327859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c327859"]])

export default __exports__